import type { EdpTimeslot } from './experience-booking-utils'
import { serializeExperienceInterval } from './experience-date-range'
import type { ExperienceFilter } from './experience-state-types'

/** User intent only; availability and prices stay in the query cache. */
export type EdpTimeslotSelection = Pick<EdpTimeslot, 'id' | 'date'> & {
  scope: string
}

export function getEdpTimeslotSelectionScope(experienceId: string, filter: ExperienceFilter) {
  const { from, to } = serializeExperienceInterval(filter)
  // Quantities are deliberately excluded: revalidate the same departure for the new party.
  return JSON.stringify([experienceId, filter.selectedVariant, from, to])
}
